import { default as Table } from "../AdvTableForReport";
import { default as AdvReportV } from "./AdvReport";

import { assertArray, assertString } from "core/validation";
import { get, unionBy, uniq } from "lodash";
import { connect } from "react-redux";
import { actions as fromActions } from "../../advertising/logic/formActions";
import { actions as contactActions } from "../../contact/logic/contactActions";
import { default as AdvMessage } from "../ReportMessage";
import { REPORT_TYPE } from "../common";
import { actions } from "./logic/advReportActions";

export function getReportTypesStrByAdvTypes(advertisementTypes) {
    if (assertArray(advertisementTypes)) {
        let reportTypes = [];
        const advNames = [];
        advertisementTypes.map((a) => {
            if (assertArray(a.reportTypes)) {
                reportTypes = unionBy(a.reportTypes, reportTypes, (r) => r.id);
            } else {
                advNames.push(a.nameSingular);
            }
        });
        const namesReport = assertArray(reportTypes) ? reportTypes.map((r) => r.name) : [];
        const namesAd = assertArray(advNames) ? uniq(advNames) : [];
        const allNames = [...namesReport, ...namesAd];
        return assertArray(allNames) ? allNames.filter((t) => assertString(t)).join(" /") : "";
    }
    return "";
}
export const AdvReport = connect(
    (state) => ({
        advertisersCount: state.reportAdv.advertisersCount,
        filmRelease: state.reportAdv.filmRelease,

        advertisementTypes: state.reportAdv.advertisementTypes,
        loadingStatus: state.reportAdv.loadingStatus,
        ccList: state.reportAdv.ccList,
        primaryUser: state.reportAdv.primaryUser,
        sendingEmail: state.reportAdv.sendingEmail,
        contactState: state.contacts,
    }),
    (dispatch) => ({
        onLoadReportView: (loadAds) => dispatch(actions.ON_LOAD_REPORT_VIEW.send({ loadAds })),
        onClear: () => dispatch(actions.ON_CLEAR_REPORT.call()),
        onPreviewPdf: (date, primaryContactId, primaryContactName, comment) =>
            dispatch(actions.ON_PREVIEW_REPORT.call({ date, primaryContactId, primaryContactName, comment })),
        onSetPrimaryUser: (contact) => dispatch(actions.ON_SET_PRIMARY_USER.call(contact)),
        onSetCCList: (contacts) => dispatch(actions.ON_SET_CC_LIST.call(contacts)),
        onResetEmailState: () => dispatch(actions.ON_RESET_EMAIL_SEND_REPORT.call()),
        saveContact: (contact) => dispatch(contactActions.SAVE_CONTACT.send(contact)),
        getCompanyAndContacts: (id) => dispatch(contactActions.GET_COMPANY.send(id)),
        onSendEmail: (date, primaryContactId, primaryContactName, comment, message) =>
            dispatch(actions.ON_SEND_REPORT.send({ date, primaryContactId, primaryContactName, comment, message })),
    })
)(AdvReportV);

export const AdvReportMessage = connect(
    (state) => ({
        reportType: REPORT_TYPE.ADV,
        invalidFilmRelease: get(state.reportAdv.logicError, "invalidFilmRelease", null),
        currentFilmRelease: get(state.reportAdv, "filmRelease", null),
    }),
    (dispatch) => ({
        onClearError: () => dispatch(actions.ON_CLEAR_REPORT_ERROR.call()),
        onAcceptNewFilmRelease: () => dispatch(actions.ON_CLEAR_WITH_NEW_FILM_RELEASE.call()),
    })
)(AdvMessage);

export const ReportAdvTable = connect(
    (state) => ({
        advertisers: state.reportAdv.advToReport,
        advertisementTypes: state.reportAdv.advertisementTypes,
        reportType: REPORT_TYPE.ADV,
    }),
    (dispatch) => ({
        onFilterByType: (typeId) => dispatch(actions.ON_FILTER_BY_TYPE.call(typeId)),
        onRemoveFromReport: (adv) => dispatch(actions.ON_REMOVE_FROM_REPORT.call(adv)),
        toggleAdvertisingForm: (editing, id) =>
            dispatch(fromActions.TOGGLE_ADVERTISING_FORM.send({ editing, id, fromDetails: true })),
    })
)(Table);
